import React, { useRef, useEffect, useState } from "react";
import { string, func, bool } from "prop-types";

import { SearchBox } from "../../../atoms/SearchBoxBase";
import SearchIcon from "../../../atoms/icons/search-icon";
import { staticTexts } from "../../../utils/Translate";

import "./navbarSearch.m.css";

const DrawForm = ({ children }) => [
  <label htmlFor="searchForm" key="1" styleName="search-label" className="search-label">
    {children}
  </label>,
  <button aria-label="search" type="submit" styleName="search__form-submit" className="search-form-submit" key="2">
    <SearchIcon />
  </button>,
];

const NavbarSearch = ({ device = "desktop", searchClick, closeBtn = true, toggleVerticalMenubar }) => {
  const textInput = useRef();
  const searchForm = useRef();
  const [searchFocus, setSearchFocus] = useState(false);

  useEffect(() => {
    const focusHandler = () => {
      setSearchFocus(true);
    };

    const blurHandler = () => {
      setSearchFocus(false);
    };

    if (textInput && textInput.current) {
      textInput.current.addEventListener("focus", focusHandler);
      textInput.current.addEventListener("blur", blurHandler);

      return () => {
        textInput.current.removeEventListener("focus", focusHandler);
        textInput.current.removeEventListener("blur", blurHandler);
      };
    }
  }, [textInput]);

  useEffect(() => {
    const inputElements = document.getElementsByTagName("input");
    Array.from(inputElements).forEach((item) => item.blur());
  }, []);

  return (
    <div styleName={`search ${device}`} className="search">
      {closeBtn && (
        <span styleName="close-btn" className="search-close-btn" onClick={searchClick}>
          X
        </span>
      )}
      <SearchBox
        styleName={`search-box ${searchFocus ? "search-active" : ""}`}
        inputId="searchForm"
        inputClassName="search-form-input"
        template={DrawForm}
        inputRef={textInput}
        formRef={searchForm}
        toggleVerticalMenubar={toggleVerticalMenubar}
        placeholder={staticTexts().searchBoxText}
        className="search-box"
      />
    </div>
  );
};

NavbarSearch.propTypes = {
  closeBtn: bool,
  device: string,
  searchClick: func,
  toggleVerticalMenubar: func,
};

export default NavbarSearch;
